export interface IStyling
{
    color?: string | null;
    ['background-color']?: string | null;
}

export class GraphStyleHelper
{
    public default(): IStyling
    {
        return { color: '', 'background-color': '' };
    }

    public isValid(value: string): boolean
    {
        if (value.trim() === '')
        {
            return true;
        }
        let parsed: unknown;
        try
        {
            parsed = JSON.parse(value);
        }
        catch
        {
            return false;
        }
        if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed))
        {
            return false;
        }
        const allowedKeys = ['color', 'background-color'];
        const parsedObj = parsed as Record<string, unknown>;
        for (const key of allowedKeys)
        {
            if (!(key in parsedObj))
            {
                return false;
            }
        }
        for (const [key, val] of Object.entries(parsedObj))
        {
            if (!allowedKeys.includes(key))
            {
                return false;
            }
            if (val !== null && typeof val !== 'string')
            {
                return false;
            }
        }
        return true;
    }

    public parse(value: string): IStyling | undefined
    {
        if (value.trim() === '' || !this.isValid(value))
        {
            return undefined;
        }
        return JSON.parse(value) as IStyling;
    }

    public toJsonString(styling: IStyling | null | undefined): string
    {
        return JSON.stringify(styling ?? this.default(), null, 2);
    }
}
